// Mock data for the presidential dashboard
// Regions of Ethiopia
export const regions = [
  { id: 'addis', name: 'Addis Ababa', lat: 9.0222, lng: 38.7468, performance: 0.87 },
  { id: 'afar', name: 'Afar', lat: 11.7500, lng: 41.0000, performance: 0.62 },
  { id: 'amhara', name: 'Amhara', lat: 11.5000, lng: 38.0000, performance: 0.76 },
  { id: 'benishangul', name: 'Benishangul-Gumuz', lat: 10.7500, lng: 35.1000, performance: 0.58 },
  { id: 'dire', name: 'Dire Dawa', lat: 9.5930, lng: 42.5000, performance: 0.81 },
  { id: 'gambela', name: 'Gambela', lat: 8.2500, lng: 34.5833, performance: 0.54 },
  { id: 'harari', name: 'Harari', lat: 9.3100, lng: 41.8661, performance: 0.79 },
  { id: 'oromia', name: 'Oromia', lat: 7.0000, lng: 39.0000, performance: 0.72 },
  { id: 'somali', name: 'Somali', lat: 8.0000, lng: 44.0000, performance: 0.61 },
  { id: 'southern', name: 'Southern Nations', lat: 7.0000, lng: 37.0000, performance: 0.68 },
  { id: 'tigray', name: 'Tigray', lat: 14.0000, lng: 38.0000, performance: 0.65 }
]
// Headline KPIs
export const headlineKPIs = {
  totalServices: {
    value: 217,
    target: 250,
    progress: 0.87
  },
  totalRequests: {
    value: 1483756,
    prevValue: 1356892,
    change: 0.09
  },
  citizenSatisfaction: {
    value: 0.85,
    prevValue: 0.82,
    change: 0.03
  },
  revenueCollected: {
    value: 2750000000,
    prevValue: 2420000000,
    change: 0.14
  },
  slaCompliance: {
    value: 0.92,
    prevValue: 0.89,
    change: 0.03
  }
}
// Service Performance
export const topServices = [
  { name: 'Business Registration', volume: 187432, sla: 0.94, avgTime: 1.2 },
  { name: 'National ID Application', volume: 156789, sla: 0.96, avgTime: 2.5 },
  { name: 'Land Title Transfer', volume: 98765, sla: 0.87, avgTime: 5.3 },
  { name: 'Driver\'s License Renewal', volume: 87654, sla: 0.92, avgTime: 0.8 },
  { name: 'Birth Certificate', volume: 76543, sla: 0.91, avgTime: 1.5 }
]
export const poorPerformingServices = [
  { name: 'Building Permit', volume: 23456, sla: 0.63, avgTime: 18.7 },
  { name: 'Agricultural License', volume: 12345, sla: 0.68, avgTime: 12.3 },
  { name: 'Import License', volume: 9876, sla: 0.72, avgTime: 10.5 },
  { name: 'Marriage Certificate', volume: 8765, sla: 0.75, avgTime: 8.2 },
  { name: 'Tax Clearance', volume: 7654, sla: 0.78, avgTime: 7.8 }
]
export const serviceStatusDistribution = [
  { status: 'Completed', value: 1245678 },
  { status: 'In Progress', value: 187654 },
  { status: 'Pending', value: 43210 },
  { status: 'Rejected', value: 7214 }
]
export const channelUsage = [
  { channel: 'Online Portal', value: 867543 },
  { channel: 'Mobile App', value: 432156 },
  { channel: 'Kiosks', value: 98765 },
  { channel: 'Service Centers', value: 85292 }
]
// Citizen Engagement
export const userGrowth = [
  { month: 'Jan', citizens: 1200000, businesses: 78000 },
  { month: 'Feb', citizens: 1250000, businesses: 82000 },
  { month: 'Mar', citizens: 1320000, businesses: 87000 },
  { month: 'Apr', citizens: 1410000, businesses: 93000 },
  { month: 'May', citizens: 1520000, businesses: 99000 },
  { month: 'Jun', citizens: 1650000, businesses: 105000 },
  { month: 'Jul', citizens: 1780000, businesses: 112000 },
  { month: 'Aug', citizens: 1900000, businesses: 119000 },
  { month: 'Sep', citizens: 2050000, businesses: 127000 },
  { month: 'Oct', citizens: 2200000, businesses: 136000 },
  { month: 'Nov', citizens: 2350000, businesses: 145000 },
  { month: 'Dec', citizens: 2500000, businesses: 155000 }
]
export const satisfactionTrend = [
  { month: 'Jan', value: 0.78 },
  { month: 'Feb', value: 0.79 },
  { month: 'Mar', value: 0.81 },
  { month: 'Apr', value: 0.82 },
  { month: 'May', value: 0.83 },
  { month: 'Jun', value: 0.82 },
  { month: 'Jul', value: 0.84 },
  { month: 'Aug', value: 0.85 },
  { month: 'Sep', value: 0.86 },
  { month: 'Oct', value: 0.87 },
  { month: 'Nov', value: 0.86 },
  { month: 'Dec', value: 0.85 }
]
export const feedbackThemes = [
  { theme: 'Fast Service', sentiment: 'positive', weight: 85 },
  { theme: 'User Friendly', sentiment: 'positive', weight: 72 },
  { theme: 'Efficient Process', sentiment: 'positive', weight: 68 },
  { theme: 'System Errors', sentiment: 'negative', weight: 42 },
  { theme: 'Confusing Interface', sentiment: 'negative', weight: 38 },
  { theme: 'Long Wait Times', sentiment: 'negative', weight: 35 }
]
export const complaintStats = {
  open: 1875,
  resolved: 12543,
  resolutionRate: 0.87
}
// Economic Impact
export const economicImpact = {
  newBusinesses: 18756,
  landTitles: 45678,
  timeSaved: 5600000, // hours
  costSaved: 870000000 // currency
}
// Financial Data
export const financialOverview = {
  budgetedRevenue: 3500000000,
  actualRevenue: 2750000000,
  budgetedExpenditure: 1200000000,
  actualExpenditure: 980000000,
  topRevenueServices: [
    { name: 'Business Registration', revenue: 620000000 },
    { name: 'Land Title Transfer', revenue: 450000000 },
    { name: 'Import License', revenue: 380000000 },
    { name: 'Vehicle Registration', revenue: 340000000 },
    { name: 'Construction Permits', revenue: 310000000 }
  ]
}
// System Health
export const systemHealth = {
  uptime: 0.9998,
  securityIndex: 0.94,
  auditLogActivity: 'Normal'
}
// Key Initiatives
export const keyInitiatives = [
  {
    name: 'Digital ID Program',
    target: 20000000,
    current: 15600000,
    progress: 0.78,
    impact: 'Enabling secure access to all government services'
  },
  {
    name: 'Land Digitization',
    target: 12000000,
    current: 7800000,
    progress: 0.65,
    impact: 'Reducing land disputes by 45% in digitized areas'
  },
  {
    name: 'Business Express',
    target: 200000,
    current: 167000,
    progress: 0.84,
    impact: 'Reduced business registration time from 15 days to 1 day'
  },
  {
    name: 'Rural Connectivity',
    target: 15000,
    current: 9200,
    progress: 0.61,
    impact: 'Bringing e-services to remote communities via 9,200 kiosks'
  }
]
// Time filters
export const timeFilters = [
  { id: 'today', label: 'Today' },
  { id: 'last7', label: 'Last 7 Days' },
  { id: 'last30', label: 'Last 30 Days' },
  { id: 'mtd', label: 'Month to Date' },
  { id: 'qtd', label: 'Quarter to Date' },
  { id: 'ytd', label: 'Year to Date' },
  { id: 'prevYear', label: 'Previous Year' },
  { id: 'custom', label: 'Custom Range' }
]
// Jurisdiction filters
export const jurisdictionFilters = [
  { id: 'national', label: 'National' },
  ...regions.map(region => ({ id: region.id, label: region.name }))
]
// Service category filters
export const serviceCategoryFilters = [
  { id: 'all', label: 'All Services' },
  { id: 'civil', label: 'Civil Registration' },
  { id: 'business', label: 'Business Services' },
  { id: 'land', label: 'Land Management' },
  { id: 'health', label: 'Health' },
  { id: 'transport', label: 'Transportation' },
  { id: 'finance', label: 'Finance' },
  { id: 'education', label: 'Education' },
  { id: 'agriculture', label: 'Agriculture' }
]